'use client'

/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-no-comment-textnodes */
import useIsMobile from '@/hooks/useIsMobile'
import { cn } from '@admin/lib/utils'
import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/24/solid'
import Image from 'next/image'
import React, { useState } from 'react'


const Featurevideo = (
  { src = '', thumbnail = '', onEnded = () => {}, isMuted = true, toggleVolumeControl = () => {} },
  ref: any,
) => {
  const { isMobile } = useIsMobile()
  const [isLoading, setIsLoading] = useState(false)
  const VolumeIcon = isMuted ? SpeakerXMarkIcon : SpeakerWaveIcon

  const handleVideoLoaded = () => {
    setIsLoading(false)
  }

  return (
    <div className="border border-[#D9DCE1] p-2 rounded-xl overflow-hidden w-full h-full min-h-[190px]">
      <div className="rounded-lg overflow-hidden relative w-full h-full">
        <div className="relative md:rounded-xl overflow-hidden w-full h-full">
          <video
            src={src}
            ref={ref}
            className={cn(
              'h-full w-full object-cover',
              isLoading ? 'opacity-0' : 'opacity-100'
            )}
            onLoadStart={() => setIsLoading(true)}
            onLoadedData={handleVideoLoaded}
            playsInline
            onEndedCapture={onEnded}
            muted={isMuted}
            preload='none'
            poster={thumbnail}
            title='Hand’s-On Learning and More!'
            aria-label='Explore Our Latest Product Features'
          />

          {!isLoading && (
            <div className="absolute bottom-4 right-4">
              <VolumeIcon
                className="cursor-pointer"
                onClick={toggleVolumeControl}
                width={isMobile ? 18 : 30}
                height={isMobile ? 18 : 30}
                color='#fff'
                title={isMuted ? 'Unmute' : 'Mute'}
              />
            </div>
          )}

          {isLoading && (
            <div className="absolute inset-0">
              <div className="bg-orange-100 w-full h-full flex items-center justify-center">
                {thumbnail && thumbnail.trim() !== '' ? (
                  <Image
                    src={thumbnail}
                    width={16}
                    height={9}
                    layout='responsive'
                    alt='Video Thumbnail'
                    loading='lazy'
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-orange-100 to-orange-200 flex items-center justify-center aspect-[16/9]">
                    <div className="text-orange-600 text-4xl opacity-60">▶</div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default React.forwardRef(Featurevideo)
